export default "__VITE_ASSET__f7d8300d__"